import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Button from '../components/elements/button';

import classes from '@/scss/screens/booking-confirmed.module.scss';

import IconMailSent from '../assets/icon-mail-sent.svg?react';

export default function BookingConfirmed() {
    const navigate = useNavigate();
    const { token } = useParams();
    const { t } = useTranslation();

    return (
        <>
            <div className={`${classes.main}`}>
                <IconMailSent />
                <span>{t('wizard:reservationConfirmed:title')}</span>
                <p>{t('wizard:reservationConfirmed:subtitle')}</p>
                <Button
                    onclick={() => {
                        navigate(`/move-in/${token}`);
                    }}
                    type='primary'
                    size='medium'
                >
                    {t('wizard:reservationConfirmed:finaliseBooking')}
                </Button>
            </div>
        </>
    );
}
